export const DELETE_HEADER = className => 'Delete ' + className + '?'
export const DELETE_MESSAGE = "If you delete it, it's gone forever."
export const DELETE_MESSAGE_SHARED =
  "If you delete it, it's gone forever for everyone."
export const DELETE_NOTICE =
  'This class will no longer appear on your SecondStep.org dashboard, and its data will be permanently lost.'
export const DELETE_NOTICE_SHARED =
  "The class will no longer appear on your Second Step® account or on any co-teacher's account. The class's data will be permanently lost."
export const DELETE_CONFIRM = 'Got it'
export const DELETE_SUBMIT = 'DELETE CLASS'
export const DELETE_CANCEL = 'CANCEL'

// Small Group specific labels
export const DELETE_NOTICE_SMALL_GROUP =
  'This small group will no longer appear on your SecondStep.org dashboard, and its data will be permanently lost.'
export const DELETE_SUBMIT_SMALL_GROUP = 'DELETE SMALL GROUP'
